import { observer } from 'mobx-react-lite';
import { BoloAdditionalInfos } from '../../../bolos/bolo-panel/additional-infos/bolo-additional-infos';

export const FrBoloUpdatesTab = observer(() => <BoloAdditionalInfos />);
